import React from 'react';

/**
 * Formats caption text to preserve line breaks and paragraph spacing
 * 
 * @param {string} text - The caption text to format
 * @returns {JSX.Element} - Formatted text with preserved spacing
 */
export const formatCaption = (text) => {
  if (!text) return null;
  
  const paragraphs = text.split(/\n\n+/);
  
  return (
    <>
      {paragraphs.map((paragraph, index) => {
        const lines = paragraph.split(/\n/);
        
        return (
          <p key={index} className={index > 0 ? 'mt-2' : ''}>
            {lines.map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {lineIndex > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </>
  );
};
